import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@core/services/userHandler/user.service';
import { environment } from '@environments/environment';
import { DialogModalComponent } from '@core/components/dialog-modal/dialog-modal.component';
import { RegexService } from '@core/services/regex.service';
import { RecaptchaComponent, RecaptchaModule } from 'ng-recaptcha';
import { MaterialModule } from 'src/app/material.module';
import { DataLayerService } from '@core/services/data-layer.service';
import { NotificationService } from '@core/services/notification.service';

@Component({
  selector: 'cgw-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule, RecaptchaModule, CommonModule],
})
export class RegisterComponent implements OnInit, OnDestroy {
  registerPersonForm: UntypedFormGroup;
  registerPerson: boolean = true;
  recaptchaGoogle: string;
  hide: boolean = true;
  hide1: boolean = true;
  @Output() returnLogin = new EventEmitter();
  @Output() returnClose = new EventEmitter();
  @ViewChild('captchaRef', { static: true }) public captchaRef: RecaptchaComponent;
  constructor(
    private fb: UntypedFormBuilder,
    private regex: RegexService,
    private userService: UserService,
    public dialogRef: MatDialogRef<DialogModalComponent>,
    public dialog: MatDialog,
    public dialogRef2: MatDialogRef<DialogModalComponent>,
    private dataLayerService: DataLayerService,
  ) {
    this.recaptchaGoogle = environment.recaptcha_site;
  }

  ngOnInit(): void {
    this.registerPersonForm = this.fb.group(
      {
        name: ['', Validators.required],
        lastname: ['', Validators.required],
        email: ['', [Validators.required, Validators.pattern(this.regex.mail)]],
        cod_area: [
          '',
          [Validators.required, Validators.pattern(this.regex.numeric), Validators.maxLength(4)],
        ],
        telefono: [
          '',
          [Validators.required, Validators.pattern(this.regex.numeric), Validators.maxLength(10)],
        ],
        password: ['', [Validators.required, Validators.pattern(this.regex.passwordComplete)]],
        passwordRep: ['', [Validators.required]],
      },
      {
        // check whether our password and confirm password match
        validator: RegexService.passwordMatchValidator,
      },
    );
  }

  registerUser(captcha) {
    this.dialogRef2 = this.dialog.open(DialogModalComponent, {
      width: 'auto',
      height: 'auto',
      maxWidth: '95vw',
      disableClose: true,
      data: { type: 'loadingBloq' },
    });
    let dataForm = this.registerPersonForm.value;
    const data = {
      nombre: dataForm.name,
      apellido: dataForm.lastname,
      mail: dataForm.email,
      telefono: dataForm.telefono,
      codigo_de_area: dataForm.cod_area,
      id_tipo: 3,
      id_cate: 1,
      clave: dataForm.password,
      captchaResponse: captcha,
    };
    this.userService.registerNewUser(data).subscribe({
      next: (res: any) => {
        if (res && res.ResultCode === 200) {
          switch (res.Message) {
            case 'OK':
              this.dialogRef = this.dialog.open(DialogModalComponent, {
                width: '440px',
                height: 'auto',
                maxWidth: '95vw',
                disableClose: true,
                data: { type: 'userRegister' },
              });
              this.dialogRef.afterClosed().subscribe((res) => {
                if (res) {
                  this.goToLogin();
                }
              });
              //Evento google analytics
              this.dataLayerService.signup(data.mail);
              break;
            case 'Usuario ya existe':
              this.dialogRef = this.dialog.open(DialogModalComponent, {
                width: '440px',
                height: 'auto',
                maxWidth: '95vw',
                disableClose: true,
                data: { type: 'userExist' },
              });
              this.dialogRef.afterClosed().subscribe((res) => {
                if (res) {
                  this.goToLogin();
                }
              });
            default:
              break;
          }
          this.dialogRef2.close();
        }
      },
      error: () => {
        this.dialogRef2.close();
        NotificationService.showError();
      },
    });
  }

  goToLogin() {
    this.returnLogin.emit(false);
  }

  ngOnDestroy() {
    const captchaElem = this.captchaRef['elementRef'].nativeElement;
    captchaElem.parentElement.removeChild(captchaElem);
  }
}
